angular.module('CarsSaraBo').config(['$routeProvider', function($routeProvider) {
	$routeProvider.when("/markup", {
		template: '<markup-component></markup-component>',
		title: 'layout.HOME',
        sidebar: 'markup'
	});
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/markup/markup.route.js
// module id = 890
// module chunks = 3